import { PagedResult } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils";

import { GroupProgramRequestsListItem, CreateGroupProgramRequestRequest } from"../../models/GroupProgramRequest";
import { ExportGroupProgramRequestsRequest } from "./ExportGroupProgramRequestsRequest";
import { GroupProgramRequestsListSearchRequest } from "./GroupProgramRequestsListSearchRequest";


const groupProgramRequestsUrlPrefix: string = "group-program-requests";

export const getGroupProgramRequests = async (request: GroupProgramRequestsListSearchRequest) => {
    return (api.get(
        groupProgramRequestsUrlPrefix + "/program-requests-list",
        request    
    )as Promise<GroupProgramRequestsListItem[]>);
};

export const createGroupProgramRequest = async (request: CreateGroupProgramRequestRequest) => {
    return api.post(
        groupProgramRequestsUrlPrefix,
        request
    ) as Promise<number>;
};

export const exportGroupProgramRequests = async (request: ExportGroupProgramRequestsRequest) => {
    var result = await (api.download(
        groupProgramRequestsUrlPrefix + "/export",
        "get",
        request
    ) as Promise<unknown>);
    return result;
};